"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Register_1 = __importDefault(require("./Register"));
var EnvironmentContainer = /** @class */ (function () {
    function EnvironmentContainer() {
    }
    EnvironmentContainer.initialize = function () {
        if (!EnvironmentContainer.instance) {
            EnvironmentContainer.instance = new EnvironmentContainer;
            for (var key in Register_1.default)
                EnvironmentContainer.instance.set(key, Register_1.default[key]);
        }
        return EnvironmentContainer.instance;
    };
    EnvironmentContainer.prototype.set = function (key, value) {
        EnvironmentContainer.environment[key] = value;
        return this;
    };
    EnvironmentContainer.prototype.setMany = function (vars) {
        for (var key in vars)
            EnvironmentContainer.instance.set(key, vars[key]);
        return this;
    };
    EnvironmentContainer.prototype.get = function (key) {
        return EnvironmentContainer.environment[key] || null;
    };
    EnvironmentContainer.prototype.getMany = function (keys) {
        var result = {};
        for (var key in keys)
            result[key] = EnvironmentContainer.environment[key] || null;
        return result;
    };
    EnvironmentContainer.prototype.getAll = function () {
        return EnvironmentContainer.environment;
    };
    EnvironmentContainer.environment = {};
    return EnvironmentContainer;
}());
exports.EnvironmentContainer = EnvironmentContainer;
var environment = function () {
    return EnvironmentContainer.initialize();
};
exports.default = environment;
//# sourceMappingURL=EnvironmentContainer.js.map